import React from 'react'
import { useState, useEffect, useRef } from 'react';

import '../../../assets/styles/styles.css'
import '../../../assets/styles/lobby-table.css'

import nakamaUtilInstance, { user, client, session } from '../../../utils/nakama';
import CreateGameModal from './CreateGameModal.jsx';
import AvailableCard from '../../DeckBuilder/components/AvailableCard.jsx';
import { playSound, handleClickSound } from '../../game/scenes/classes/PlaySound';

import pfp1 from '../../../assets/images/panda_pfp.png'
import bonezIcon from '../../../assets/images/bonez_icon.svg'
import chipzIcon from '../../../assets/images/bonez_chipz_credit.webp'
import goldMedal from '../../../assets/images/gold_medal.svg'
import silverMedal from '../../../assets/images/silver_medal.svg'
import bronzeMedal from '../../../assets/images/bronze_medal.svg'
import blueButton from '../../../assets/images/blue_button_400.webp'
import cooldownIcon from '../../../assets/images/cooldown.png'

import { Tab, Tabs, Table, Row, Col, Image, Dropdown, Button, Offcanvas, Toast, ToastContainer } from 'react-bootstrap';
import eventsCenter, { PHASER_EVENTS } from '../../../utils/phaserEvents.js';

// Bot user IDs for identification in lobby
const BOT_IDS = [
  "cbd2c3d9-64ac-4021-be10-39e50089bb1a",
  "36d518fa-6190-4a9a-811e-ec8add072af2",
  "1005cca9-ad17-4c93-8b83-bc8b594416b4",
  "ad7064af-0b82-408c-817f-4f019077bed2",
  "bee1502c-8391-4bcd-a60d-7dd4328da95c",
  "a16291a2-c4a1-427f-b7a7-83d088171058",
  "c517f045-7dbb-4b82-ba11-0c3db76144b6",
  "8ae5c033-bc43-48cd-801e-579e3081a48d"
];

const isBot = (userId) => BOT_IDS.includes(userId);

function LobbyTable(props) {

  const [leaderboardTypeSelected, setLeaderboardTypeSelected] = useState("tournament"); // tournament, global
  const [leaderboardSelection, setLeaderboardSelection] = useState("wins"); // wins, zoom, bonez
  const [selectedTournamentIndex, setSelectedTournamentIndex] = useState(0); //array index of selected tournament
  const [leaderboardDisplayData, setLeaderboardDisplayData] = useState([]);
  const [leaderboardDisplayPfp, setLeaderboardDisplayPfp] = useState([]);
  const [rankWins, setRankWins] = useState(null);
  const [rankZoomWon, setRankZoomWon] = useState(null);
  const [rankBonezWon, setRankBonezWon] = useState(null);
  const [friendsList, setFriendsList] = useState();
  const [loadedFriends, setLoadedFriends] = useState(false);
  const [gamesSelection, setGamesSelection] = useState("all");

  const [activeGames, setActiveGames] = useState("-");
  const [availableGames, setAvailableGames] = useState("-");

  // game modal states
  const [showCreateModal, setShowCreateModal] = useState(false);


  const [cardCollection, setCardCollection] = useState({ housePowerCards: new Map(), nftPowerCards: new Map() });
  const [refreshCardCollectionTrigger, setRefreshCardCollectionTrigger] = useState(false); //changed when a card is dropped into the power deck

  //Power deck related variables
  const [droppedItems, setDroppedItems] = useState([]);
  const [dropIndicator, setDropIndicator] = useState(false);

  // Destructure props
  const { loadingSpectate, setLoadingSpectate } = props;
  const [cardPreview, setCardPreview] = useState("");
  const [houseCardPreview, setHouseCardPreview] = useState();

  const [deckLoaded, setDeckLoaded] = useState(false);
  const [cardSlots, setCardSlots] = useState([]); // for displaying the cards in the power deck
  const deckLoadedRef = useRef(deckLoaded);

  //update the card count (/10)
  const [cardCount, setCardCount] = useState(0);
  const cardCountRef = useRef(cardCount);
  const setCardCountRef = (update) => {
    cardCountRef.current = update;
    setCardCount(update);
  }

  const [selectedOption, setSelectedOption] = useState('Both');

  // Add these new state variables
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [selectedPlayerStats, setSelectedPlayerStats] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('success'); // success or error
  // cooldown countdown timer
  const [countdown, setCountdown] = useState('');
  // Cooldown countdown timestamp
  const [penaltyEnds, setPenaltyEnds] = useState(0);


  // Events emitted from Phaser
  const setupInternalPhaserEventListeners = () => {
    if (eventsCenter.listeners(PHASER_EVENTS.BUY_OPEN_PACK).length < 1) {
      eventsCenter.on(PHASER_EVENTS.BUY_OPEN_PACK, (payload) => {
        setRefreshCardCollectionTrigger(true);
      });
    }
  }

  useEffect(() => {
    setupInternalPhaserEventListeners();
  }, []);

  useEffect(() => {
    if (props.availableMatchesQuery.isSuccess && props.availableMatchesQuery.data?.payload) {
      setActiveGames(props.availableMatchesQuery.data.payload.activeMatches?.length || 0);
      setAvailableGames(props.availableMatchesQuery.data.payload.availableMatches?.length || 0);
    }

  }, [props.availableMatchesQuery.isSuccess && props.availableMatchesQuery.data.payload.availableMatches, props.availableMatchesQuery.isSuccess && props.availableMatchesQuery.data.payload.activeMatches]);

  useEffect(() => {
    function updateRankStates() {
      if (props.leaderboardsQuery.data && user && user.id) {
        const recordsWin = props.leaderboardsQuery.data?.payload?.winsLeaderboard?.records || [];
        const recordsZoom = props.leaderboardsQuery.data?.payload?.zoomWonLeaderboard?.records || [];
        const recordsBonez = props.leaderboardsQuery.data?.payload?.bonezWonLeaderboard?.records || [];
        const userRecordWin = recordsWin.find(record => record.ownerId === user.id);
        const userRecordZoom = recordsZoom.find(record => record.ownerId === user.id);
        const userRecordBonez = recordsBonez.find(record => record.ownerId === user.id);
        if (userRecordWin) {
          setRankWins(userRecordWin.rank);
        }
        else {
          setRankWins(null);
        }
        if (userRecordZoom) {
          setRankZoomWon(userRecordZoom.rank);
        }
        else {
          setRankZoomWon(null);
        }
        if (userRecordBonez) {
          setRankBonezWon(userRecordBonez.rank);
        }
        else {
          setRankBonezWon(null);
        }
      }
    }

    if (props.leaderboardsQuery.isSuccess) {
      updateRankStates();
    }
  }, [props.leaderboardsQuery]);

  useEffect(() => {
    //console.log("Update view", leaderboardTypeSelected, leaderboardSelection, props.leaderboardsQuery);
    if (props.leaderboardsQuery.isSuccess) {
      // console.log("Leaderboards Query Success", props.leaderboardsQuery.data.payload);
      let displayData;
      //Leaderbords or Tournaments
      if (leaderboardTypeSelected === "global") {
        if (leaderboardSelection === "wins") {
          displayData = props.leaderboardsQuery.data?.payload?.winsLeaderboard?.records || [];
        }
        else if (leaderboardSelection === "zoom") {
          displayData = props.leaderboardsQuery.data?.payload?.zoomWonLeaderboard?.records || [];
        }
        else if (leaderboardSelection === "bonez") {
          displayData = props.leaderboardsQuery.data?.payload?.bonezWonLeaderboard?.records || [];
        }
      } else { //tournaments
        displayData = props.leaderboardsQuery.data?.payload?.tournamentRecords?.[selectedTournamentIndex]?.records || null;
      }

      if (displayData !== null && displayData.length > 0) {
        setLeaderboardDisplayData(displayData);

        const userIds = displayData.map(record => record.ownerId);
        const avatarMap = retrieveAvatarUrls(userIds);
        avatarMap.then((avatarUrls) => {
          const avatarUrlsFinal = displayData.map(record =>
            avatarUrls.get(record.ownerId) || pfp1
          );
          //console.log("Final avatar URLs:", avatarUrlsFinal);
          setLeaderboardDisplayPfp(avatarUrlsFinal);
        });
      } else {
        // Clear display data if no records available
        setLeaderboardDisplayData([]);
        setLeaderboardDisplayPfp([]);
      }
    }
  }, [leaderboardTypeSelected, leaderboardSelection, props.leaderboardsQuery]);

  useEffect(() => {
    const getFriends = async () => {
      if (client && session && loadedFriends) {
        try {
          var result = await client.listFriends(session);
          var friendMap = new Map();
          for (var friend in result.friends) {
            const friendData = result.friends[friend].user;
            friendMap.set(friendData.id, friendData.username);
          }
          setFriendsList(friendMap)
        } catch (err) {
          console.log("Error getting friends list: ", err);
          // Only call sessionTimeoutCheck for actual authentication errors (401, 403)
          if (err.code === 16 || err.message?.includes('UNAUTHENTICATED') || err.message?.includes('session')) {
            nakamaUtilInstance.sessionTimeoutCheck();
          }
        }
      }
      else {
        setTimeout(() => setLoadedFriends(!loadedFriends), 100);
      }
    }
    getFriends();
  }, [client, session, loadedFriends])

  //get available power cards
  useEffect(() => {
    const getPowerCards = async () => {
      if (!client || !session) {
        console.log("Client or session not initialized, skipping power cards fetch");
        return;
      }
      const response = ((await client.rpc(session, "fetchAvailablePowerCards", "lobby-table")).payload);
      if (response.housePowerCards && response.nftPowerCards) {
        setCardCollection({
          housePowerCards: new Map(response.housePowerCards),
          nftPowerCards: new Map(response.nftPowerCards)
        });
        setRefreshCardCollectionTrigger(false);
      }
      else {
        console.error("Error fetching power cards: ", response.message);
      }
    }

    getPowerCards();
    return () => {
      setRefreshCardCollectionTrigger(false);
    }
  }, [refreshCardCollectionTrigger, props.callRefreshCardCollection]);

  //update rendering functions
  const [renderHouseCards, setRenderHouseCards] = useState(() => () => { });
  const [renderNftCards, setRenderNftCards] = useState(() => () => { });
  useEffect(() => {
    const renderHouseCardsFunction = () => {
      const renderCards = [];
      for (const [key, value] of cardCollection.housePowerCards.entries()) {
        renderCards.push(
          <div key={key} className="grid-item">
            <AvailableCard
              setDropIndicator={setDropIndicator}
              handleCardSelect={handleCardSelect}
              cardCollection={cardCollection}
              isDropped={isDropped(key)}
              houseCard={true}
              cardName={key}
              numberOwned={value}
              draggable={cardCountRef.current < 10}
            />
          </div>
        );
      }
      return renderCards;
    };

    setRenderHouseCards(() => renderHouseCardsFunction);

    const renderNftCardsFunction = () => {
      const renderCards = [];
      for (const [key, value] of cardCollection.nftPowerCards.entries()) {
        renderCards.push(
          <div key={key} className="grid-item">
            <AvailableCard
              setDropIndicator={setDropIndicator}
              cardCollection={cardCollection}
              handleCardSelect={handleCardSelect}
              isDropped={isDropped(key)}
              houseCard={false}
              cardName={key}
              numberOwned={value}
              draggable={cardCountRef.current < 10}
            />
          </div>
        );
      }
      return renderCards;
    };

    setRenderNftCards(() => renderNftCardsFunction);
  }, [cardCollection]);

  //get power deck
  useEffect(() => {
    async function getPowerDeck() {
      if (!client || !session) {
        console.log("Client or session not initialized, skipping power deck fetch");
        return;
      }
      const powerDeck = await client.readStorageObjects(session, {
        "object_ids": [{
          "collection": "bonez_power_deck",
          "key": "power_deck",
          "user_id": session.user_id
        }]
      })

      // console.log(powerDeck.objects[0].value.data);
      // setNakamaDeck(powerDeck.objects[0].value.data);
      const nakamaDeck = powerDeck.objects[0].value.data
      const housePowerCards = new Map(nakamaDeck.housePowerCards);
      const nftPowerCards = new Map(nakamaDeck.nftPowerCards);

      let index = 0;
      let droppedIndex = 0;
      var newDeck = [
        { image: "", count: 0 },
        { image: "", count: 0 },
        { image: "", count: 0 },
        { image: "", count: 0 },
        { image: "", count: 0 },
        { image: "", count: 0 },
        { image: "", count: 0 },
        { image: "", count: 0 },
        { image: "", count: 0 },
        { image: "", count: 0 }
      ];

      housePowerCards.forEach((value, key) => {
        //if (!deckLoaded) {
        newDeck[index] = {
          image: key,
          count: value,
          houseCard: true
        }
        //}
        if (key !== "") index++;
        droppedIndex += value;
        for (var i = 0; i < value; i++) {
          if (cardCountRef.current < droppedIndex) {
            droppedItems.push(key);
          }
        }
      });
      nftPowerCards.forEach((value, key) => {
        //if (!deckLoaded) {
        newDeck[index] = {
          image: key,
          count: value,
          houseCard: false,
        }
        //}
        if (key !== "") index++;
        droppedIndex += value;
        for (var j = 0; j < value; j++) {
          if (cardCountRef.current < droppedIndex) {
            droppedItems.push(key);
          }
        }
      });
      setCardSlots(newDeck);
      //setDeckLoaded(true);
    }
    getPowerDeck();
  }, [deckLoadedRef, refreshCardCollectionTrigger]);

  useEffect(() => {
    if (cardSlots) {
      let count = 0;
      cardSlots.map((slot) => {
        if (slot.image !== "") {
          count += slot.count;
        }
      })
      setCardCountRef(count);
    }
  }, [cardSlots, cardCount]);

  //function to pass to the card collection component to change the card in the left pane preview screen
  const handleCardSelect = (cardName, houseCard) => {
    // console.log(cardName)
    setCardPreview(cardName);
    setHouseCardPreview(houseCard);
  }

  //dnd function to track when a card has been placed in another row
  function isDropped(cardName) {
    //have to account for card count when its added
    return droppedItems.indexOf(cardName) > -1;
  }

  async function retrieveAvatarUrls(userIds, retryCount = 0) {
    const maxRetries = 2;
    const retryDelay = 1000 * (retryCount + 1);

    try {
      const uniqueUserIds = [...new Set(userIds)];
      const response = await client.getUsers(session, uniqueUserIds);

      const avatarMap = new Map();
      if (response.users) {
        response.users.forEach(user => {
          //console.log("User avatar data:", user.id, user.avatar_url);
          // Check if the URL is valid and has a proper format
          const avatarUrl = user.avatar_url && user.avatar_url.startsWith('http')
            ? user.avatar_url
            : pfp1;
          avatarMap.set(user.id, avatarUrl);
        });
      }

      return avatarMap;
    } catch (error) {
      console.error("Error retrieving avatar URLs:", error);

      // Retry on server errors (500) but not on authentication errors
      if (retryCount < maxRetries &&
        (error.message?.includes('500') || error.message?.includes('Internal Server Error'))) {
        console.log(`Retrying avatar retrieval in ${retryDelay}ms... (attempt ${retryCount + 1}/${maxRetries})`);
        return new Promise((resolve) => {
          setTimeout(async () => {
            const result = await retrieveAvatarUrls(userIds, retryCount + 1);
            resolve(result);
          }, retryDelay);
        });
      }

      // For auth errors, don't retry
      if (error.code === 16 || error.message?.includes('UNAUTHENTICATED')) {
        console.log("Authentication error in avatar retrieval, skipping retry");
      }

      // Return empty map with default avatars for all users
      const fallbackMap = new Map();
      userIds.forEach(userId => {
        fallbackMap.set(userId, pfp1);
      });
      return fallbackMap;
    }
  }

  async function handleCreateGame() {
    props.createGame();

    // close the modal
    setShowCreateModal(false);
  }

  // Add this function to handle div clicks
  const handleProfileClick = async (player) => {
    //Get the bonez match SO
    let matchSO = null;
    try {
      const response = await client.readStorageObjects(session, {
        object_ids: [
          {
            collection: "bonez_matches",
            key: "bonez_matches",
            user_id: player.ownerId
          },
        ],
      });
      matchSO = response.objects[0].value.data;
    } catch (error) {
      console.error("Error retrieving player bonez match SO:", error);
    }
    setSelectedPlayerStats(matchSO);
    setSelectedPlayer(player);
    setShowOffcanvas(true);
    playSound("clickSound");
  };

  // Add this function to handle closing the Offcanvas
  const handleCloseOffcanvas = () => {
    setShowOffcanvas(false);
    setSelectedPlayer(null);
  };

  const handleAddFriend = async (playerId) => {
    try {
      const response = await client.addFriends(session, [playerId]);
      if (response) {
        console.log("Friend added:", response);

        // Show success toast
        setToastMessage("Friend request sent successfully!");
        setToastType('success');
        setShowToast(true);
      } else {
        console.error("Error adding friend:", response);

        // Show error toast
        setToastMessage("Error sending friend request");
        setToastType('danger');
        setShowToast(true);
      }
    } catch (error) {
      console.error("Error adding friend:", error);

      // Show error toast
      setToastMessage("Error sending friend request: " + error.message);
      setToastType('danger');
      setShowToast(true);
    }
  };

  useEffect(() => {
    // Only start the countdown if we have a penalized opponent selected
    if (selectedPlayer && props.penalizedOpponents &&
      props.penalizedOpponents.some(opponent => opponent.id === selectedPlayer.ownerId)) {

      // Find the opponent in the penalized list
      const penalizedOpponent = props.penalizedOpponents.find(opponent => opponent.id === selectedPlayer.ownerId);

      // Get the penalty end timestamp
      const penaltyEndsTemp = Math.floor(penalizedOpponent?.penaltyEnds / 1000) || 0;
      setPenaltyEnds(penaltyEndsTemp);

      // Update countdown initially
      updateCountdown(penaltyEndsTemp);

      // Store the end time in a ref to avoid closure issues
      const endTimeRef = { current: penaltyEndsTemp };

      // Set up interval to update countdown every second
      const interval = setInterval(() => {
        updateCountdown(endTimeRef.current);
      }, 1000);

      // Clean up interval on unmount or when selected player changes
      return () => clearInterval(interval);
    }
  }, [selectedPlayer, props.penalizedOpponents]);

  // Function to calculate and format the countdown
  const updateCountdown = (endTime) => {
    const now = Math.floor(Date.now() / 1000);
    const timeLeft = endTime - now;

    if (timeLeft <= 0) {
      setCountdown('00:00:00');
      return;
    }

    // Calculate hours, minutes, seconds
    const hours = Math.floor(timeLeft / 3600);
    const minutes = Math.floor((timeLeft % 3600) / 60);
    const seconds = timeLeft % 60;

    // Format as hh:mm:ss
    const formattedTime =
      `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    setCountdown(formattedTime);
  };

  return (
    <>
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1100 }}>
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          bg={toastType}
        >
          <Toast.Header>
            <strong className="me-auto">{toastType === 'success' ? 'Success' : 'Error'}</strong>
          </Toast.Header>
          <Toast.Body className={toastType === 'success' ? 'text-white' : 'text-white'}>
            {toastMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>

      <CreateGameModal
        showModal={showCreateModal}
        setShowModal={setShowCreateModal}
        createGame={handleCreateGame}
        wagerType={props.wagerType}
        setWagerType={props.setWagerType}
        potAmount={props.potAmount}
        setPotAmount={props.setPotAmount}
        zoomBalance={props.zoomBalance}
        bonezBalance={props.bonezBalance}
      />

      <Tabs
        className='lobby-tabs container-title'
        defaultActiveKey="available-games"
        fill
      >
        <Tab tabClassName="lobby-tab page-fit-stretchable" eventKey="available-games" title={`Available Matches (${availableGames})`}>

          <div className="table-responsive" style={{ backgroundColor: "transparent" }}>
            <Row className="leaderboard-header-container">
              <Col className='leaderboard-header-labels'>
                <span className='tournament-button' onClick={() => setGamesSelection("all")}>All Games</span>  |&nbsp;
                <span className='tournament-button' onClick={() => setGamesSelection("tribe")}>My Tribe</span>
              </Col>
              <Col style={{ textAlign: "right", marginRight: "2rem", color: "#FFFFFF" }}>
                {gamesSelection === "all" ? "All Games" : "My Tribe"}
              </Col>
            </Row>

            {
              props.availableMatchesQuery.isSuccess && (!props.availableMatchesQuery.data?.payload?.availableMatches || props.availableMatchesQuery.data.payload.availableMatches.length === 0)
                ? (
                  <div className="" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "65vh", overflowY: "auto" }}>
                    <div className="container-body-text lobby-table-text">
                      <img
                        className="icon chipz"
                        title="Zoombies Chipz"
                        src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                        alt="Chipz icon"
                      />
                      There are no matches available to join.
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "15px" }}>
                      <button
                        className={`button mb-5 create-game-button ${(props.gamesCreated > 2 || props.isLoadingMatches) ? "button-disabled" : ""}`}
                        onClick={(e) => {
                          playSound("clickSound");
                          setShowCreateModal(true);
                        }}
                        disabled={(props.gamesCreated > 2 || props.isLoadingMatches)}
                      >
                        <audio id="clickSound" className="sound-fx" hidden>
                          <source src="/bonez/sounds/click.mp3" type="audio/mp3" />
                          Your browser does not support the audio element.
                        </audio>
                        <img
                          src="https://zoombies.world/images/dapp/green_button_400.webp"
                          alt=""
                          style={{ width: "105%", height: "100%" }}
                        />
                        <span
                          className="button-text"
                          style={{ color: "#000000" }}
                        >
                          {props.isLoadingMatches ? "CREATING..." : "CREATE MATCH"}
                        </span>
                      </button>
                    </div>
                    <br />
                    <div className="container-body-text lobby-table-friends-text mt-5">
                      Bonez is real-time PvP, invite a friend to play!
                    </div>
                    <button
                      className='button create-game-button'
                      onClick={(e) => {
                        playSound("clickSound");
                        props.setIsInviteBarActive(!props.isInviteBarActive);
                      }}
                    >
                      <img
                        className="icon friends"
                        src={blueButton}
                        alt=""
                        style={{ width: "105%", height: "100%" }}
                      />
                      <span
                        className="button-text friends"
                        style={{ color: "#000000" }}
                      >
                        INVITE FRIENDS
                      </span>
                    </button>
                  </div>
                )
                : (
                  <Table>
                    <thead className="lobby-table-header container-title">
                      <tr>
                        <th>Playing For</th>
                        <th>Wager</th>
                        <th>Host Player</th>
                        <th>Play</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.availableMatchesQuery.isSuccess && props.availableMatchesQuery.data.payload.availableMatches && props.availableMatchesQuery.data.payload.availableMatches.map((match) => (
                        (gamesSelection === "all" || (gamesSelection === "tribe" && friendsList.get(match.label.hostId) !== undefined)) &&
                        <tr className="lobby-table-row" key={match.matchId}>
                          <td>
                            <div className="">
                              {props.penalizedOpponents && props.penalizedOpponents.some(opponent => opponent.id === match.label.hostId) && (
                                <img src={cooldownIcon} alt="Cooldown" style={{ maxWidth: "25px" }} />
                              )}
                              {match.label.wagerType === 'bonez' ? (
                                <>
                                  <img className="table-icon" title="Zoombies Bones" alt="" src={bonezIcon} />
                                </>
                              ) : (
                                <img
                                  className="chipz-icon stat-icon"
                                  title="Zoombies Chipz"
                                  src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                  alt="Chipz icon"
                                />
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="">
                              <span className="container-body-text">{(match.label.potAmount / 2).toLocaleString()}</span>
                            </div>
                          </td>
                          <td>
                            <div className="">
                              <Image
                                alt=""
                                className="table-pfp"
                                style={{ marginRight: "3%" }}
                                src={match.label.hostAvatarUrl ? match.label.hostAvatarUrl : pfp1}
                                roundedCircle
                              />
                              <span className="container-body-text">{match.label.hostUsername}{isBot(match.label.hostId) && " 🤖"}</span>
                            </div>
                          </td>
                          <td>
                            {user && ((user.id === match.label.hostId) ? (
                              <button
                                className={`button table-button ${(props.isCancelling.includes(match.matchId)) && "button-disabled"}`}
                                onClick={(e) => {
                                  playSound("clickSound");
                                  props.leaveMatch(match.matchId)
                                }}
                                disabled={(props.isCancelling.includes(match.matchId))}
                              >
                                <img
                                  src="https://zoombies.world/images/dapp/red_button_400.webp"
                                  style={{ width: "105%", height: "100%" }}
                                  alt="button"
                                />
                                <span className="button-text table-button-text">
                                  {(props.isCancelling.includes(match.matchId)) ? "CANCELLING" : "CANCEL"}
                                </span>
                              </button>
                            ) : (
                              <button
                                className="button table-button"
                                onClick={() => {
                                  props.joinMatch(match.matchId, match.label.potAmount - match.label.tableFee, match.label.wagerType, match.label.potAmount / 2);
                                }}
                              >
                                <img
                                  src="https://zoombies.world/images/dapp/green_button_500.webp"
                                  style={{ width: "100%", height: "100%" }}
                                  alt="button"
                                />
                                <span className="button-text table-button-text">
                                  JOIN
                                </span>
                              </button>
                            ))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )
            }

            <div id="anchor"></div>
          </div>
        </Tab>
        <Tab tabClassName="lobby-tab page-fit-stretchable" eventKey="active-games" title={`Active Matches (${activeGames})`}>
          <div className="table-responsive">

            {
              props.availableMatchesQuery.isSuccess && (!props.availableMatchesQuery.data?.payload?.activeMatches || props.availableMatchesQuery.data.payload.activeMatches.length === 0)
                ? (
                  <div className="mt-5" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <div className="container-body-text lobby-table-text">
                      <img
                        className="icon chipz"
                        title="Zoombies Chipz"
                        src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                        alt="Chipz icon"
                      />
                      There are no matches available to join.
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "15px" }}>
                      <button
                        className={`button create-game-button ${(props.gamesCreated > 2 || props.isLoadingMatches) ? "button-disabled" : ""}`}
                        onClick={(e) => {
                          playSound("clickSound");
                          setShowCreateModal(true);
                        }}
                        disabled={(props.gamesCreated > 2 || props.isLoadingMatches)}
                      >
                        <audio id="clickSound" className="sound-fx" hidden>
                          <source src="/bonez/sounds/click.mp3" type="audio/mp3" />
                          Your browser does not support the audio element.
                        </audio>
                        <img
                          src="https://zoombies.world/images/dapp/green_button_400.webp"
                          alt=""
                          style={{ width: "105%", height: "100%" }}
                        />
                        <span
                          className="button-text"
                          style={{ color: "#000000" }}
                        >
                          {props.isLoadingMatches ? "CREATING..." : "CREATE MATCH"}
                        </span>
                      </button>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "5%" }}>
                      <img className="icon bonez" title="Zoombies Bones" style={{ transform: "rotate(155deg)" }} alt="" src={bonezIcon} />
                      <div className="container-body-text lobby-table-bonez-text">
                        WANT MORE BONEZ?
                      </div>
                      <img className="icon bonez" title="Zoombies Bones" style={{ transform: "rotate(205deg) scaleX(-1)" }} alt="" src={bonezIcon} />
                    </div>
                    <div className="container-body-text lobby-table-friends-text">
                      Friends can send you bonez every day!
                    </div>
                    <button
                      className='button create-game-button'
                      onClick={(e) => {
                        playSound("clickSound");
                        window.open("https://zoombies.world/auth/friends");
                      }}
                    >
                      <img
                        className="icon friends"
                        src={blueButton}
                        alt=""
                        style={{ width: "105%", height: "100%" }}
                      />
                      <span
                        className="button-text friends"
                        style={{ color: "#000000" }}
                      >
                        INVITE FRIENDS
                      </span>
                    </button>
                  </div>
                )
                : (
                  <Table>
                    <thead className="lobby-table-header container-title">
                      <tr>
                        <th>Playing For</th>
                        <th>Wager</th>
                        <th>Players</th>
                        <th>Spectate</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.availableMatchesQuery.isSuccess && props.availableMatchesQuery.data.payload.activeMatches && props.availableMatchesQuery.data.payload.activeMatches.map((match) => (
                        <tr className="lobby-table-row" key={match.matchId}>
                          <td>
                            <div className="">
                              {match.label.wagerType === 'bonez' ? (
                                <>
                                  <img className="table-icon" alt="" src={bonezIcon} />
                                </>
                              ) : (
                                <img
                                  className="chipz-icon stat-icon"
                                  title="Zoombies Chipz"
                                  src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                  alt="Chipz icon"
                                />
                              )}
                            </div>
                          </td>
                          <td >
                            <div className="">
                              <span className="container-body-text">{(match.label.potAmount / 2).toLocaleString()}</span>
                            </div>
                          </td>
                          <td>
                            <div className="">
                              <span className="container-body-text">
                                {isBot(match.label.hostId) && "🤖 "}{match.label.hostUsername}
                                <span className="vs-text"> vs </span>
                                {isBot(match.label.player2Id) && "🤖 "}{match.label.player2Username}
                              </span>
                            </div>
                          </td>
                          <td>
                            {/* Show loading button if this match is being joined, regardless of canSpectate */}
                            {loadingSpectate === match.matchId ? (
                              <button
                                className="button table-button button-disabled"
                                disabled={true}
                              >
                                <img
                                  src="https://zoombies.world/images/dapp/green_button_500.webp"
                                  style={{ width: "100%", height: "100%", opacity: 0.6 }}
                                  alt="button"
                                />
                                <span className="button-text table-button-text">
                                  LOADING...
                                </span>
                              </button>
                            ) : match.label.canSpectate ? (
                              <>
                                {(props.spectating < 25) &&
                                  <button
                                    className="button table-button"
                                    onClick={() => {
                                      setLoadingSpectate(match.matchId);
                                      props.joinMatch(match.matchId);
                                    }}
                                  >
                                    <img
                                      src="https://zoombies.world/images/dapp/green_button_500.webp"
                                      style={{ width: "100%", height: "100%" }}
                                      alt="button"
                                    />
                                    <span className="button-text table-button-text">
                                      WATCH
                                    </span>
                                  </button>}
                                {(props.spectating >= 25) &&
                                  <button
                                    className="button table-button button-disabled"
                                    disabled={true}
                                  >
                                    <img
                                      src="https://zoombies.world/images/dapp/green_button_500.webp"
                                      style={{ width: "100%", height: "100%" }}
                                      alt="button"
                                    />
                                    <span className="button-text table-button-text">
                                      GAME FULL
                                    </span>
                                  </button>
                                }
                              </>
                            ) : (
                              <button
                                className="button table-button button-disabled"
                                disabled={true}
                              >
                                <img
                                  src="https://zoombies.world/images/dapp/green_button_500.webp"
                                  style={{ width: "100%", height: "100%" }}
                                  alt="button"
                                />
                                <span className="button-text table-button-text">
                                  LOADING...
                                </span>
                              </button>

                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )
            }
          </div>
        </Tab>

        <Tab tabClassName="lobby-tab page-fit-stretchable" eventKey="leaderboards" title="Leaderboards">
          <div className="table-responsive">
            <Row className="leaderboard-header-container">
              <Col className='leaderboard-header-labels'>
                <span className='leaderboard-header-labels' onClick={() => { setLeaderboardTypeSelected("tournament"); setLeaderboardSelection("") }}>Tournaments</span> |&nbsp;
                <span className='leaderboard-header-labels' onClick={() => { setLeaderboardTypeSelected("global") }}>Global Leaderboards</span>
              </Col>
            </Row>
            {leaderboardTypeSelected === "global" ? (
              <Row className="leaderboard-header-container leaderboard-header-labels">
                <Col style={{ textAlign: "right", marginRight: "2rem", color: "#FFFFFF" }}>
                  <span className='tournament-button' onClick={() => setLeaderboardSelection("wins")}>Total Wins</span> |&nbsp;
                  <span className='tournament-button' onClick={() => setLeaderboardSelection("zoom")}><img style={{ maxHeight: "24px" }} src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp" alt="Chipz icon" /> Chipz Won</span> |&nbsp;
                  <span className='tournament-button' onClick={() => setLeaderboardSelection("bonez")}><img style={{ maxHeight: "28px" }} src={bonezIcon} alt="Bonez icon" /> Bonez Won</span>
                </Col>
              </Row>
            ) : (
              <Row className="leaderboard-header-container">
                <Col style={{ textAlign: "right", marginRight: "2rem", color: "#FFFFFF" }} className="mb-2">
                  {(props.leaderboardsQuery.isSuccess && props.leaderboardsQuery.data.payload.allTournaments && props.leaderboardsQuery.data.payload.allTournaments.tournaments.length > 0) ? (
                    <>
                      {props.leaderboardsQuery.data.payload.allTournaments.tournaments.map((tournament, index) => (
                        <React.Fragment key={index}>
                          <span className='tournament-button' onClick={() => setSelectedTournamentIndex(index)}> <img style={{ maxHeight: "28px" }} src={tournament.metadata.type === 'bonez' ? bonezIcon : chipzIcon} alt="Bonez icon" /> {tournament.title} { }</span>
                          {index < props.leaderboardsQuery.data.payload.allTournaments.tournaments.length - 1 && `  |  `}
                        </React.Fragment>
                      ))}
                    </>
                  ) : (
                    <>
                      &nbsp;
                    </>
                  )}
                </Col>
              </Row>
            )}

            {leaderboardTypeSelected === "global" ? /*Render the global leaderboards - Current rank and column header*/(
              <div>
                <Row style={{ paddingTop: "1%", paddingBottom: "1%" }}>
                  <div style={{ display: 'flex' }}>
                    <Col lg="4" sm="4">
                      <div>
                        <h3 className="container-body-text leaderboard-user-rank" style={{ marginRight: "32%", color: "#dc78ff" }}>{leaderboardSelection === "wins" ? 'Total Wins' : leaderboardSelection === "zoom" ? 'ChipZ Won' : 'Bonez Won'}</h3>
                      </div>
                    </Col>
                    <Col lg="2" sm="3">
                      <h1 className="container-body-text leaderboard-user-rank">Your Rank: </h1>
                      {leaderboardSelection === "wins" && props.leaderboardsQuery.isSuccess &&
                        <h1 className="container-body-text leaderboard-user-rank" style={{ color: '#FF0A54', paddingLeft: "2%" }}>{rankWins ? rankWins.toLocaleString() : "N/A"}</h1>
                      }
                      {leaderboardSelection === "zoom" && props.leaderboardsQuery.isSuccess &&
                        <h1 className="container-body-text leaderboard-user-rank" style={{ color: '#FF0A54', paddingLeft: "2%" }}>{rankZoomWon ? rankZoomWon.toLocaleString() : "N/A"}</h1>
                      }
                      {leaderboardSelection === "bonez" && props.leaderboardsQuery.isSuccess &&
                        <h1 className="container-body-text leaderboard-user-rank" style={{ color: '#FF0A54', paddingLeft: "2%" }}>{rankBonezWon ? rankBonezWon.toLocaleString() : "N/A"}</h1>
                      }
                    </Col>
                    <Col lg="2" sm="3">
                      <h1 className="container-subtitle leaderboard-title">{leaderboardSelection === "wins" ? "Wins" : leaderboardSelection === "zoom" ? "Chipz Won" : "Bones Won"}</h1>
                    </Col>
                    {leaderboardSelection !== "wins" && props.leaderboardsQuery.isSuccess &&
                      <Col lg={4} sm={2}>
                        <div>
                          <h1 className="container-subtitle leaderboard-title">Matches</h1>
                        </div>
                      </Col>
                    }
                  </div>
                </Row>

                <Row>
                  {props.leaderboardsQuery.isSuccess && leaderboardDisplayData.map((record, index) => {
                    return (
                      <div key={record.rank}>
                        {record.rank === 1 &&
                          <div
                            className="leaderboard-profile-container"
                            style={{ backgroundColor: '#585EDD', cursor: 'pointer' }}
                            onClick={() => handleProfileClick(record)}
                          >
                            <div style={{ display: 'flex' }}>
                              <Col lg={1} sm={1}>
                                <div className="leaderboard-medal">
                                  <img style={{ width: "100%", height: "100%" }} src={goldMedal} alt="" />
                                </div>
                              </Col>

                              <Col lg="4" sm="6" style={{ textAlign: "left" }}>
                                <Image src={leaderboardDisplayPfp[index]} className="leaderboard-pfp" alt="" roundedCircle />
                                <span className="container-body-text" style={{ color: "#FFFFFF" }}>{record.username}</span>
                              </Col>

                              <Col lg="4" sm="3">
                                <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.score.toLocaleString()}</span>
                              </Col>
                              {leaderboardSelection !== "wins" && props.leaderboardsQuery.isSuccess &&
                                <Col lg={2} sm={2}>
                                  <div>
                                    <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.numScore.toLocaleString()}</span>
                                  </div>
                                </Col>
                              }
                            </div>
                          </div>
                        }
                        {record.rank === 2 &&
                          <div
                            className="leaderboard-profile-container"
                            style={{ backgroundColor: '#585EDD', cursor: 'pointer' }}
                            onClick={() => handleProfileClick(record)}
                          >
                            <div style={{ display: 'flex' }}>
                              <Col lg={1} sm={1}>
                                <div className="leaderboard-medal">
                                  <img style={{ width: "100%", height: "100%" }} src={silverMedal} alt="" />
                                </div>
                              </Col>

                              <Col lg="4" sm="6" style={{ textAlign: "left" }}>
                                <Image src={leaderboardDisplayPfp[index]} className="leaderboard-pfp" alt="" roundedCircle />
                                <span className="container-body-text" style={{ color: "#FFFFFF" }}>{record.username}</span>
                              </Col>

                              <Col lg="4" sm="3">
                                <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.score.toLocaleString()}</span>
                              </Col>
                              {leaderboardSelection !== "wins" && props.leaderboardsQuery.isSuccess &&
                                <Col lg={2} sm={2}>
                                  <div>
                                    <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.numScore.toLocaleString()}</span>
                                  </div>
                                </Col>
                              }
                            </div>
                          </div>
                        }
                        {record.rank === 3 &&
                          <div
                            className="leaderboard-profile-container"
                            style={{ backgroundColor: '#585EDD', cursor: 'pointer' }}
                            onClick={() => handleProfileClick(record)}
                          >
                            <div style={{ display: 'flex' }}>
                              <Col lg={1} sm={1}>
                                <div className="leaderboard-medal">
                                  <img style={{ width: "100%", height: "100%" }} src={bronzeMedal} alt="" />
                                </div>
                              </Col>
                              <Col lg="4" sm="6" style={{ textAlign: "left" }}>
                                <Image src={leaderboardDisplayPfp[index]} className="leaderboard-pfp" alt="" roundedCircle />
                                <span className="container-body-text" style={{ color: "#FFFFFF" }}>{record.username}</span>
                              </Col>

                              <Col lg="4" sm="3">
                                <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.score.toLocaleString()}</span>
                              </Col>
                              {leaderboardSelection !== "wins" && props.leaderboardsQuery.isSuccess &&
                                <Col lg={2} sm={2}>
                                  <div>
                                    <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.numScore.toLocaleString()}</span>
                                  </div>
                                </Col>
                              }
                            </div>
                          </div>
                        }
                        {record.rank > 3 &&
                          <div
                            className="leaderboard-profile-container"
                            style={{ display: 'flex', backgroundColor: record.rank % 2 === 0 ? '#20235C' : '', cursor: 'pointer' }}
                            onClick={() => handleProfileClick(record)}
                          >
                            <Col lg={1} sm={1}>
                              <span className="container-body-text">{record.rank.toLocaleString()}</span>
                            </Col>

                            <Col lg="4" sm="6" style={{ textAlign: "left" }}>
                              <Image src={leaderboardDisplayPfp[index]} className="leaderboard-pfp" alt="" roundedCircle />
                              <span className="container-body-text" style={{ color: "#FFFFFF" }}>{record.username}</span>
                            </Col>

                            <Col lg="4" sm="3">
                              <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.score.toLocaleString()}</span>
                            </Col>
                            {leaderboardSelection !== "wins" && props.leaderboardsQuery.isSuccess &&
                              <Col lg={2} sm={2}>
                                <div>
                                  <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.numScore.toLocaleString()}</span>
                                </div>
                              </Col>
                            }
                          </div>
                        }
                      </div>
                    )
                  })
                  }
                </Row>
              </div>
            ) : /* Render the Tournaments tables */(
              <>
                <Row style={{ paddingTop: "1%", paddingBottom: "1%" }}>
                  <div style={{ display: 'flex' }}>
                    <Col lg="3" sm="3">
                      <h1 className="container-body-text leaderboard-user-rank" style={{ marginRight: "32%", color: "#dc78ff" }}> <img style={{ maxHeight: "28px" }} src={props.leaderboardsQuery.data?.payload?.allTournaments?.tournaments?.[selectedTournamentIndex]?.metadata?.type === 'bonez' ? bonezIcon : chipzIcon} alt="Bonez icon" /> {props.leaderboardsQuery.isSuccess && props.leaderboardsQuery.data?.payload?.allTournaments?.tournaments?.length > 0 ? props.leaderboardsQuery.data.payload.allTournaments.tournaments[selectedTournamentIndex].title : "N/A"}</h1>
                    </Col>
                    <Col lg="3" sm="3" className="container-body-text">
                      {selectedTournamentIndex < 1 ? 'Closes' : 'Closes'} : {props.leaderboardsQuery.isSuccess && props.leaderboardsQuery.data?.payload?.allTournaments?.tournaments?.length > 0 ? new Date(props.leaderboardsQuery.data.payload.allTournaments.tournaments[selectedTournamentIndex].endActive * 1000).toLocaleString('en-US', { timeZoneName: 'short' }) : "N/A"}
                    </Col>
                    <Col lg="2" sm="2">
                      <h1 className="container-body-text leaderboard-user-rank">Your Rank: </h1>
                      {props.leaderboardsQuery.isSuccess &&
                        <h1 className="container-body-text leaderboard-user-rank" style={{ color: '#FF0A54', paddingLeft: "2%" }}>{props.leaderboardsQuery.data?.payload?.tournamentRecords?.[selectedTournamentIndex]?.records && user && props.leaderboardsQuery.data.payload.tournamentRecords[selectedTournamentIndex].records.find(record => record.ownerId === user.id) ? props.leaderboardsQuery.data.payload.tournamentRecords[selectedTournamentIndex].records.find(record => record.ownerId === user.id).rank : "N/A"}</h1>
                      }
                    </Col>
                    <Col>
                      <h1 className="container-subtitle leaderboard-title">Points</h1>
                    </Col>
                    <Col lg={2} sm={2}>
                      <div>
                        <h1 className="container-subtitle leaderboard-title">Matches</h1>
                      </div>
                    </Col>
                  </div>
                </Row>
                <Row className="">
                  <Col style={{ textAlign: "right", marginRight: "2rem", color: "#FFFFFF" }}>
                    {(props.leaderboardsQuery.isSuccess && props.leaderboardsQuery.data?.payload?.allTournaments?.tournaments?.length > 0) ? (
                      <>
                        {(selectedTournamentIndex !== '' && props.leaderboardsQuery.data?.payload?.tournamentRecords?.[selectedTournamentIndex]?.records?.length > 0) ? (
                          <>
                            <Row>
                              {props.leaderboardsQuery.isSuccess && leaderboardDisplayData.map((record, index) => {
                                return (
                                  <div key={record.rank}>
                                    {record.rank === 1 &&
                                      <div className="leaderboard-profile-container" style={{ backgroundColor: '#585edd' }} onClick={() => handleProfileClick(record)}>
                                        <div style={{ display: 'flex' }}>
                                          <Col lg={1} sm={1}>
                                            <div className="leaderboard-medal">
                                              <img style={{ width: "100%", height: "100%" }} src={goldMedal} alt="" />
                                            </div>
                                          </Col>

                                          <Col lg="5" sm="4" style={{ textAlign: "left" }}>
                                            <Image src={leaderboardDisplayPfp[index]} className="leaderboard-pfp" alt="" roundedCircle />
                                            <span className="container-body-text" style={{ color: "#FFFFFF" }}>{record.username}</span>
                                          </Col>

                                          <Col lg="3" sm="4">
                                            <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.score.toLocaleString()}</span>
                                          </Col>

                                          <Col lg={2} sm={2}>
                                            <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.numScore.toLocaleString()}</span>
                                          </Col>
                                        </div>
                                      </div>
                                    }
                                    {record.rank === 2 &&
                                      <div className="leaderboard-profile-container" style={{ backgroundColor: '#3337a0' }} onClick={() => handleProfileClick(record)}>
                                        <div style={{ display: 'flex' }}>
                                          <Col lg={1} sm={1}>
                                            <div className="leaderboard-medal">
                                              <img style={{ width: "100%", height: "100%" }} src={silverMedal} alt="" />
                                            </div>
                                          </Col>

                                          <Col lg="5" sm="4" style={{ textAlign: "left" }}>
                                            <Image src={leaderboardDisplayPfp[index]} className="leaderboard-pfp" alt="" roundedCircle />
                                            <span className="container-body-text" style={{ color: "#FFFFFF" }}>{record.username}</span>
                                          </Col>

                                          <Col lg="3" sm="4">
                                            <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.score.toLocaleString()}</span>
                                          </Col>
                                          <Col lg={2} sm={2}>
                                            <div>
                                              <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.numScore.toLocaleString()}</span>
                                            </div>
                                          </Col>
                                        </div>
                                      </div>
                                    }
                                    {record.rank === 3 &&
                                      <div className="leaderboard-profile-container" style={{ backgroundColor: '#202266' }} onClick={() => handleProfileClick(record)}>
                                        <div style={{ display: 'flex' }}>
                                          <Col lg={1} sm={1}>
                                            <div className="leaderboard-medal">
                                              <img style={{ width: "100%", height: "100%" }} src={bronzeMedal} alt="" />
                                            </div>
                                          </Col>

                                          <Col lg="5" sm="4" style={{ textAlign: "left" }}>
                                            <Image src={leaderboardDisplayPfp[index]} className="leaderboard-pfp" alt="" roundedCircle />
                                            <span className="container-body-text" style={{ color: "#FFFFFF" }}>{record.username}</span>
                                          </Col>

                                          <Col lg="3" sm="4">
                                            <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.score.toLocaleString()}</span>
                                          </Col>
                                          <Col lg={2} sm={2}>
                                            <div>
                                              <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.numScore.toLocaleString()}</span>
                                            </div>
                                          </Col>
                                        </div>
                                      </div>
                                    }
                                    {record.rank > 3 &&
                                      <div className="leaderboard-profile-container" style={{ display: 'flex', backgroundColor: record.rank % 2 === 0 ? '#202253' : '', cursor: 'pointer' }} onClick={() => handleProfileClick(record)}>
                                        <Col lg={1} sm={1} style={{ textAlign: "center" }}>
                                          <span className="container-body-text">{record.rank.toLocaleString()}</span>
                                        </Col>

                                        <Col lg="5" sm="4" style={{ textAlign: "left" }}>
                                          <Image src={leaderboardDisplayPfp[index]} className="leaderboard-pfp" alt="" roundedCircle />
                                          <span className="container-body-text" style={{ color: "#FFFFFF" }}>{record.username}</span>
                                        </Col>

                                        <Col lg="3" sm="4">
                                          <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.score.toLocaleString()}</span>
                                        </Col>
                                        <Col lg={2} sm={2}>
                                          <div>
                                            <span className="container-body-text leaderboard-rank" style={{ color: "#FFFFFF" }}>{record.numScore.toLocaleString()}</span>
                                          </div>
                                        </Col>
                                      </div>
                                    }
                                  </div>
                                )
                              })
                              }
                            </Row>
                          </>
                        ) : (
                          <>
                            <Row className='mt-5'>
                              <Col sm="12" md="12" lg="12" className='text-center'>
                                <span style={{ fontFamily: 'Truculenta', fontSize: '3rem', fontWeight: 'bold' }}> No Records for {props.leaderboardsQuery.data?.payload?.allTournaments?.tournaments?.[selectedTournamentIndex]?.title || "Tournament"}</span> <br />
                                {props.leaderboardsQuery.data?.payload?.allTournaments?.tournaments?.[selectedTournamentIndex]?.status === "active" ? (
                                  <>
                                    <span style={{ color: '#9ce143' }}>Create Match</span> to compete!
                                  </>
                                ) : (
                                  <>
                                    <span style={{ fontFamily: 'Truculenta', fontSize: '2rem', fontWeight: 'bold' }}>Open {props.leaderboardsQuery.data?.payload?.allTournaments?.tournaments?.[selectedTournamentIndex]?.startTime ? new Date(props.leaderboardsQuery.data.payload.allTournaments.tournaments[selectedTournamentIndex].startTime * 1000).toLocaleString('en-US', { timeZoneName: 'short' }) : "N/A"}</span><br />
                                    <span style={{ fontFamily: 'Truculenta', fontSize: '2rem', fontWeight: 'bold' }}>Close {props.leaderboardsQuery.data?.payload?.allTournaments?.tournaments?.[selectedTournamentIndex]?.endActive ? new Date(props.leaderboardsQuery.data.payload.allTournaments.tournaments[selectedTournamentIndex].endActive * 1000).toLocaleString('en-US', { timeZoneName: 'short' }) : "N/A"}</span>
                                  </>
                                )}
                              </Col>
                            </Row>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <Row className='mt-5'>
                          <Col sm="12" md="12" lg="12" className='text-center'>
                            <span style={{ fontFamily: 'Truculenta', fontSize: '4rem', fontWeight: 'bold' }}> No Tournaments<br /> Check back Soon. Click Global Leaderboards </span>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>
                </Row>
              </>
            )}

          </div>
        </Tab>
        <Tab tabClassName="lobby-tab page-fit-stretchable" eventKey="card-inventory" title="MY POWER CARDS" onSelect={(test) => console.log("SELECTED")}>
          <div className="table-responsive">
            <div className="whole-container deck-drag" style={{ flex: "1" }}>
              <div style={{ textAlign: "left", paddingLeft: "3%" }}>
                <h1 className="container-title pink-text" style={{ marginBottom: '0%' }}>My Power Card Inventory</h1>
                <h1 className="container-body-text" style={{ color: '#AFAEE1', marginLeft: '75%', marginBottom: '0%' }}>
                  <Dropdown className="deck-dropdown" style={{ display: 'inline-block' }} onSelect={value => setSelectedOption(value)}>
                    <Dropdown.Toggle
                      className="deck-dropdown-toggle"
                      variant="sucess"
                      id="dropdown-basic"
                    >
                      View
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="deck-dropdown-menu">
                      <Dropdown.Item className="deck-dropdown-text" eventKey="House" style={{ color: "#B2F1FF" }}>House Power Cards</Dropdown.Item>
                      <Dropdown.Item className="deck-dropdown-text" eventKey="NFT" style={{ color: "#B2F1FF" }}>Power Boost Cards</Dropdown.Item>
                      <Dropdown.Item className="deck-dropdown-text" eventKey="Both" style={{ color: "#BD00FF" }}>Both</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </h1>
              </div>
              <div className="grid-container">
                {cardCollection && (selectedOption === 'Both' || selectedOption === 'House') && renderHouseCards()}
                {cardCollection && (selectedOption === 'Both' || selectedOption === 'NFT') && renderNftCards()}
              </div>
            </div>
          </div>
        </Tab>
      </Tabs >

      {/* Add this Offcanvas component */}
      <Offcanvas
        show={showOffcanvas}
        onHide={handleCloseOffcanvas}
        placement="end"
        style={{
          backgroundColor: '#272B81',
          color: 'white',
          borderLeft: '2px solid #585EDD'
        }}
      >
        <Offcanvas.Header closeButton closeVariant="white">
          <Offcanvas.Title style={{ color: '#dc78ff' }}>Player Profile</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {selectedPlayer && (
            <div className="player-profile">
              <div className="text-center mb-4">
                <Image
                  src={leaderboardDisplayPfp[leaderboardDisplayData.findIndex(item => item.rank === selectedPlayer.rank)]}
                  className="player-profile-image"
                  alt=""
                  roundedCircle
                  style={{ width: '100px', height: '100px', border: '3px solid #585EDD' }}
                />
                <h2 className="mt-3" style={{ color: 'white' }}>
                  {selectedPlayer.username}
                </h2>
                <div className="player-rank" style={{ color: '#DC78FF' }}>
                  Skill Rank {(selectedPlayerStats.wins / (selectedPlayerStats.losses + selectedPlayerStats.forfeits)).toFixed(2)}
                </div>
                {props.penalizedOpponents && props.penalizedOpponents.some(opponent => opponent.id === selectedPlayer.ownerId) && penaltyEnds >= Date.now() / 1000 && (
                  <div>
                    <img src={cooldownIcon} alt="Cooldown" style={{ maxWidth: "25px" }} />
                    <span style={{ color: '#6ab7ca' }}>{countdown}</span>
                  </div>
                )}
              </div>

              <div className="player-stats">
                <div className="player-rank" style={{ color: '#DC78FF', fontSize: '22px' }}>
                  {leaderboardTypeSelected === 'global' ?
                    'Global Leaderboard' :
                    props.leaderboardsQuery.data.payload.allTournaments.tournaments[selectedTournamentIndex].title + ' Tournament'
                  }
                </div>
                <div className="stat-item d-flex justify-content-between">
                  <span><span style={{ fontSize: '16px' }}>🎗️</span> Tournament Rank</span>
                  <span>{selectedPlayer.rank}</span>
                </div>
                <div className="stat-item d-flex justify-content-between">
                  <span>
                    {leaderboardTypeSelected === 'global' && leaderboardSelection === "wins" ? "🏅 Total Wins" :
                      leaderboardTypeSelected === 'tournament' && leaderboardSelection === "wins" ? "🏅 Tournament Points" :
                        leaderboardTypeSelected === 'tournaments' && leaderboardSelection === "" ? "🏅 Tournament Points" :
                          leaderboardTypeSelected === 'global' && leaderboardSelection === "zoom" ? (
                            <><img src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp" alt="Chipz" style={{ height: '16px' }} /> Chipz Won</>
                          ) : (
                            <><img src={bonezIcon} alt="Bonez" style={{ height: '16px' }} /> Bonez Won</>
                          )}
                  </span>
                  <span>{selectedPlayer.score.toLocaleString()}</span>
                </div>

                {(leaderboardSelection !== "wins" || leaderboardTypeSelected === 'tournament') && (
                  <div className="stat-item d-flex justify-content-between">
                    <span>Tournament Matches Played:</span>
                    <span>{selectedPlayer.numScore.toLocaleString()}</span>
                  </div>
                )}

                {selectedPlayerStats && (
                  <>
                    <div className="stat-divider my-3" style={{ borderBottom: '1px solid #585EDD' }}></div>
                    <div className="player-rank" style={{ color: '#DC78FF', fontSize: '22px' }}>
                      Player Stats
                    </div>
                    <Row>
                      <Col>
                        Matches <span style={{ fontSize: '16px' }}>🎮</span> Played:
                      </Col>
                      <Col>
                        {(selectedPlayerStats.wins + selectedPlayerStats.losses + selectedPlayerStats.forfeits).toLocaleString()}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Matches <span style={{ fontSize: '16px' }}>🏆</span> <span style={{ color: '#9ce143' }}>Won</span>:
                      </Col>
                      <Col>
                        {selectedPlayerStats.wins.toLocaleString()}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Match rounds <span style={{ fontSize: '16px' }}>🏆</span> <span style={{ color: '#9ce143' }}>Won</span>:
                      </Col>
                      <Col>
                        {selectedPlayerStats.totalRoundsWon.toLocaleString()}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Matches <span style={{ fontSize: '16px' }}>💔</span> <span style={{ color: '#FF0A54' }}>Lost</span>:
                      </Col>
                      <Col>
                        {selectedPlayerStats.losses.toLocaleString()}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Matches <span style={{ fontSize: '16px' }}>🤷‍♂️</span> <span style={{ color: '#FF0A54' }}>Forfeited</span>:
                      </Col>
                      <Col>
                        {selectedPlayerStats.forfeits.toLocaleString()}
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        Total <img src={bonezIcon} alt="Bonez" style={{ height: '16px' }} /> Bones <span style={{ color: '#9ce143' }}>Won</span>:
                      </Col>
                      <Col>
                        {selectedPlayerStats.bonezWon.toLocaleString()}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Total <img src={bonezIcon} alt="Bonez" style={{ height: '16px' }} /> Bones <span style={{ color: '#FF0A54' }}>Lost</span>:
                      </Col>
                      <Col>
                        {selectedPlayerStats.bonezLost.toLocaleString()}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Total <img src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp" alt="Chipz" style={{ height: '16px' }} /> Chipz <span style={{ color: '#9ce143' }}>Won</span>:
                      </Col>
                      <Col>
                        {selectedPlayerStats.zoomWon.toLocaleString()}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Total <img src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp" alt="Chipz" style={{ height: '16px' }} /> Chipz <span style={{ color: '#FF0A54' }}> Lost</span>:
                      </Col>
                      <Col>
                        {selectedPlayerStats.zoomLost.toLocaleString()}
                      </Col>
                    </Row>

                    <div className="stat-divider my-3" style={{ borderBottom: '1px solid #585EDD' }}></div>

                    <Row>
                      <Col>
                        Biggest <img src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp" alt="Chipz" style={{ height: '16px' }} /> Chipz <span style={{ color: '#9ce143' }}>Win</span>:
                      </Col>
                      <Col>
                        {selectedPlayerStats.biggestPotWonChipz.toLocaleString()}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Biggest <img src={bonezIcon} alt="Bonez" style={{ height: '16px' }} /> Bones <span style={{ color: '#9ce143' }}>Win</span>:
                      </Col>
                      <Col>
                        {selectedPlayerStats.biggestPotWonBones.toLocaleString()}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Longest <span style={{ fontSize: '16px' }}>🏆</span> <span style={{ color: '#9ce143' }}>Win</span> Streak:
                      </Col>
                      <Col>
                        {selectedPlayerStats.winStreak.toLocaleString()}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Opponents <span style={{ fontSize: '16px' }}>👥</span> Played:
                      </Col>
                      <Col>
                        {selectedPlayerStats.opponentIds.length.toLocaleString()}
                      </Col>
                    </Row>
                  </>
                )}

                <div className="action-buttons mt-4">
                  <Button
                    className="w-100 mb-2"
                    style={{ backgroundColor: '#585EDD', border: 'none', fontSize: '18px' }}
                    onClick={() => {
                      playSound("clickSound");
                      handleCloseOffcanvas();
                      // Add functionality to add friend or challenge player
                      handleAddFriend(selectedPlayer.ownerId);
                    }}
                  >
                    Add Friend
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default LobbyTable